import { render, staticRenderFns } from "./ModalFace.vue?vue&type=template&id=26613a1c&scoped=true&"
import script from "./ModalFace.vue?vue&type=script&lang=js&"
export * from "./ModalFace.vue?vue&type=script&lang=js&"
import style0 from "./ModalFace.vue?vue&type=style&index=0&id=26613a1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26613a1c",
  null
  
)

export default component.exports